import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  availabilityTextFieldParent: {
    minWidth: 150,
  },
  availabilityFilterLabel: {
    textTransform: 'none',
  },
  availabilityButton: {
    cursor: 'text',
    fontSize: 16,
    color: theme.palette.constrastGreyDark.main,
    height: 40,
    float: 'left',
    marginTop: 10,
    marginBottom: 10,
    textTransform: 'none',
  },
  textFieldStyle: {
    width: 150,
    marginTop: 10,
    marginBottom: 10,
  },
  searchButtonPopover: {
    padding: 7,
    transform: 'translate(-8px, -16px)!important',
    width: 320,
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  alignCenter: {
    alignItems: 'center',
  },
  buttonApply: {
    height: 45,
    textTransform: 'none',
    fontSize: 20,
  },
  formControlRightFilters: {
    margin: theme.spacing(1),
  },
}));

export default styles;
